module.exports = __webpack_public_path__ + "img/bo_gal_thum_no.5e279adf.jpg";